import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setK3Docs, getK3Doc } from '../../actions';
import { useLocation } from 'react-router-dom';
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Badge,
  InputGroup,
  Modal,
  Toast,
  ToastContainer
} from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { BsPencil, BsCheck2, BsX, BsTrash, BsClipboard } from 'react-icons/bs';

class K3DocView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      doc: props.selectedDoc || { ...props.doc },
      preview: false,
      showDeleteConfirm: false,
      showToast: false,
      toastMessage: '',
      toastType: 'success'
    };
  }

  componentDidMount() {
    if (this.props.selectedDoc) {
      this.setState({ doc: this.props.selectedDoc });
    } else {
      const { id } = this.props.match.params;
      if (id) {
        this.props.getK3Doc(id);
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedDoc && this.props.selectedDoc !== prevProps.selectedDoc) {
      this.setState({ doc: this.props.selectedDoc });
    } else if (this.props.currentDoc && this.props.currentDoc !== prevProps.currentDoc) {
      this.setState({ doc: { ...this.props.currentDoc } });
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      doc: {
        ...prevState.doc,
        [name]: value
      }
    }));
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { _id, ...docData } = this.state.doc;
      const updatedDoc = {
        ...docData,
        tags: Array.isArray(docData.tags) ? docData.tags : docData.tags.split(',').map(tag => tag.trim()).filter(Boolean)
      };
      await this.props.setK3Docs([{ _id, ...updatedDoc }]);
      this.setState({ isEditing: false });
    } catch (error) {
      console.error('Error updating document:', error);
    }
  };

  toggleEdit = () => {
    this.setState(prevState => ({
      isEditing: !prevState.isEditing,
      doc: { ...prevState.doc }
    }));
  };

  togglePreview = () => {
    this.setState(prevState => ({ preview: !prevState.preview }));
  };

  handleDelete = async () => {
    try {
      const { _id } = this.state.doc;
      await this.props.setK3Docs([{ _id, is_deleted: true }]);
      this.setState({ showDeleteConfirm: false });
      if (this.props.onHide) {
        this.props.onHide();
      } else {
        this.props.history.push('/k3docs');
      }
    } catch (error) {
      console.error('Error deleting document:', error);
    }
  };

  handleCopy = (text, fieldName) => {
    navigator.clipboard.writeText(text);
    this.setState({
      showToast: true,
      toastMessage: `${fieldName} copied to clipboard!`,
      toastType: 'success'
    });
    setTimeout(() => {
      this.setState({ showToast: false });
    }, 3000);
  };

  renderContent() {
    const { doc, isEditing, preview } = this.state;

    return (
      <>
        <Row className="mb-4">
          <Col>
            <h1>
              {isEditing ? (
                <Form.Control
                  type="text"
                  name="title"
                  value={doc.title}
                  onChange={this.handleChange}
                  className="h1"
                />
              ) : (
                doc.title
              )}
            </h1>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Document MID</Form.Label>
              <div style={{ position: 'relative' }}>
                {isEditing ? (
                  <Form.Control
                    type="text"
                    name="doc_mid"
                    value={doc.doc_mid}
                    onChange={this.handleChange}
                  />
                ) : (
                  <>
                    <Form.Control
                      type="text"
                      value={doc.doc_mid}
                      readOnly
                      style={{ paddingRight: '40px' }}
                    />
                    <Button 
                      variant="outline-secondary" 
                      onClick={() => this.handleCopy(doc.doc_mid, 'Document MID')}
                      style={{
                        position: 'absolute',
                        right: '5px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        padding: '0.25rem 0.5rem',
                        border: 'none',
                        background: 'transparent'
                      }}
                    >
                      <BsClipboard size={20} />
                    </Button>
                  </>
                )}
              </div>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>ID</Form.Label>
              <div style={{ position: 'relative' }}>
                <Form.Control
                  type="text"
                  value={doc._id}
                  readOnly
                  style={{ paddingRight: '40px' }}
                />
                <Button 
                  variant="outline-secondary" 
                  onClick={() => this.handleCopy(doc._id, 'ID')}
                  style={{
                    position: 'absolute',
                    right: '5px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    padding: '0.25rem 0.5rem',
                    border: 'none',
                    background: 'transparent'
                  }}
                >
                  <BsClipboard size={20} />
                </Button>
              </div>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Type</Form.Label>
              {isEditing ? (
                <Form.Select
                  name="type"
                  value={doc.type}
                  onChange={this.handleChange}
                >
                  <option value="k3_document">K3 Document</option>
                  <option value="main_message">Commit Main Message</option>
                  <option value="sub_message">Commit Sub Message</option>
                  <option value="system_prompt">System Prompt</option>
                  <option value="agent_prompt">Agent Prompt</option>
                  <option value="agent_data">Agent Data</option>
                  <option value="other">Other</option>
                </Form.Select>
              ) : (
                <div style={{ position: 'relative' }}>
                  <Form.Control
                    type="text"
                    value={doc.type}
                    readOnly
                    style={{ paddingRight: '40px' }}
                  />
                  <Button 
                    variant="outline-secondary" 
                    onClick={() => this.handleCopy(doc.type, 'Type')}
                    style={{
                      position: 'absolute',
                      right: '5px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      padding: '0.25rem 0.5rem',
                      border: 'none',
                      background: 'transparent'
                    }}
                  >
                    <BsClipboard size={20} />
                  </Button>
                </div>
              )}
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Reference ID</Form.Label>
              <div style={{ position: 'relative' }}>
                <Form.Control
                  type="text"
                  value={doc.ref_id || '-'}
                  readOnly
                  style={{ paddingRight: '40px' }}
                />
                <Button 
                  variant="outline-secondary" 
                  onClick={() => this.handleCopy(doc.ref_id || '-', 'Reference ID')}
                  style={{
                    position: 'absolute',
                    right: '5px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    padding: '0.25rem 0.5rem',
                    border: 'none',
                    background: 'transparent'
                  }}
                >
                  <BsClipboard size={20} />
                </Button>
              </div>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Created At</Form.Label>
              <Form.Control
                type="text"
                value={new Date(doc.createdAt).toLocaleString()}
                readOnly
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Updated At</Form.Label>
              <Form.Control
                type="text"
                value={new Date(doc.updatedAt).toLocaleString()}
                readOnly
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Version</Form.Label>
              <Form.Control
                type="text"
                value={doc.version}
                readOnly
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Friendly Version</Form.Label>
              {isEditing ? (
                <Form.Control
                  type="text"
                  name="friendly_version"
                  value={doc.friendly_version}
                  onChange={this.handleChange}
                />
              ) : (
                <Form.Control
                  type="text"
                  value={doc.friendly_version}
                  readOnly
                />
              )}
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-4">
          <Form.Label>Description</Form.Label>
          <div style={{ position: 'relative' }}>
            {isEditing ? (
              <Form.Control
                as="textarea"
                name="description"
                value={doc.description || ''}
                onChange={this.handleChange}
                rows={3}
                placeholder="Enter document description..."
              />
            ) : (
              <Form.Control
                as="textarea"
                value={doc.description || ''}
                readOnly
                rows={3}
                style={{ paddingRight: '40px' }}
              />
            )}
            {!isEditing && (
              <Button 
                variant="outline-secondary" 
                onClick={() => this.handleCopy(doc.description || '', 'Description')}
                style={{
                  position: 'absolute',
                  right: '5px',
                  top: '5px',
                  padding: '0.25rem 0.5rem',
                  border: 'none',
                  background: 'transparent'
                }}
              >
                <BsClipboard size={20} />
              </Button>
            )}
          </div>
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>Tags</Form.Label>
          {isEditing ? (
            <Form.Control
              type="text"
              name="tags"
              value={Array.isArray(doc.tags) ? doc.tags.join(', ') : doc.tags}
              onChange={this.handleChange}
              placeholder="tag1, tag2, tag3"
            />
          ) : (
            <div>
              {Array.isArray(doc.tags) ? doc.tags.map(tag => (
                <Badge key={tag} bg="secondary" className="me-1">
                  {tag}
                </Badge>
              )) : doc.tags}
            </div>
          )}
        </Form.Group>

        <Form.Group className="mb-4">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <Form.Label>Content</Form.Label>
            <div>
              {!isEditing && (
                <>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={this.togglePreview}
                    className="me-2"
                  >
                    {preview ? 'Raw' : 'Preview'}
                  </Button>
                  <Button 
                    variant="outline-secondary"
                    size="sm"
                    onClick={() => this.handleCopy(doc.content || '', 'Content')}
                  >
                    <BsClipboard size={20} />
                  </Button>
                </>
              )}
            </div>
          </div>
          {isEditing ? (
            <Form.Control
              as="textarea"
              name="content"
              value={doc.content}
              onChange={this.handleChange}
              rows={15}
            />
          ) : preview ? (
            <div className="border p-3">
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw]}
              >
                {doc.content}
              </ReactMarkdown>
            </div>
          ) : (
            <Form.Control
              as="textarea"
              value={doc.content}
              readOnly
              rows={15}
            />
          )}
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>Metadata</Form.Label>
          <div style={{ position: 'relative' }}>
            {isEditing ? (
              <Form.Control
                as="textarea"
                name="metadata"
                value={JSON.stringify(doc.metadata, null, 2)}
                onChange={this.handleChange}
                rows={5}
              />
            ) : (
              <Form.Control
                as="textarea"
                value={JSON.stringify(doc.metadata, null, 2)}
                readOnly
                rows={5}
                style={{ paddingRight: '40px' }}
              />
            )}
            {!isEditing && (
              <Button 
                variant="outline-secondary" 
                onClick={() => this.handleCopy(JSON.stringify(doc.metadata, null, 2), 'Metadata')}
                style={{
                  position: 'absolute',
                  right: '5px',
                  top: '5px',
                  padding: '0.25rem 0.5rem',
                  border: 'none',
                  background: 'transparent'
                }}
              >
                <BsClipboard size={20} />
              </Button>
            )}
          </div>
        </Form.Group>

        <ToastContainer position="top-end" className="p-3">
          <Toast 
            show={this.state.showToast} 
            onClose={() => this.setState({ showToast: false })}
            bg={this.state.toastType}
            delay={3000}
            autohide
          >
            <Toast.Header closeButton={false}>
              <strong className="me-auto">Success</strong>
            </Toast.Header>
            <Toast.Body className="text-white">
              {this.state.toastMessage}
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </>
    );
  }

  render() {
    const { selectedDoc, show, onHide } = this.props;
    const { showDeleteConfirm, isEditing } = this.state;

    if (selectedDoc) {
      return (
        <>
          <Modal show={show} onHide={onHide} size="xl">
            <Modal.Header closeButton>
              <div className="d-flex justify-content-between align-items-center w-100">
                <Modal.Title>Document Details</Modal.Title>
                <Button 
                  variant="primary"
                  onClick={isEditing ? this.handleSubmit : this.toggleEdit}
                >
                  {isEditing ? (
                    <>
                      <BsCheck2 className="me-1" /> Save
                    </>
                  ) : (
                    <>
                      <BsPencil className="me-1" /> Edit
                    </>
                  )}
                </Button>
              </div>
            </Modal.Header>
            <Modal.Body>
              {this.renderContent()}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="danger" onClick={() => this.setState({ showDeleteConfirm: true })}>
                <BsTrash className="me-1" /> Delete
              </Button>
              <Button variant="secondary" onClick={onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal show={showDeleteConfirm} onHide={() => this.setState({ showDeleteConfirm: false })}>
            <Modal.Header closeButton>
              <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to delete this document? This action cannot be undone.
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => this.setState({ showDeleteConfirm: false })}>
                Cancel
              </Button>
              <Button variant="danger" onClick={this.handleDelete}>
                Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      );
    }

    return (
      <Container className="py-4">
        {this.renderContent()}
      </Container>
    );
  }
}

const K3DocViewWithRouter = (props) => {
  const location = useLocation();
  return <K3DocView {...props} location={location} />;
};

const mapStateToProps = (state) => ({
  currentDoc: state.k3docReducer.currentDoc,
});

export default connect(mapStateToProps, { setK3Docs, getK3Doc })(K3DocViewWithRouter); 